import { Injectable } from '@angular/core';
import { BaseService } from '../../abstracts/base.service';
import { ActivityModel } from '../../models/crm-model/activity.model';
import { ConnectionModel } from '../../models/crm-model/connection.model';
import { CompanyModel } from '../../models/finance/company.model';
import { ResultModel } from '../../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends BaseService {
  
  changeProfilePhoto(id: any, base64Image: string) {
    var formData = new FormData;

    formData.append('img', base64Image);
    formData.append('format', 'PNG');

    return this.httpClient.post<ResultModel>(this.getApiUrl(`companies/${id}/change-avatar`), formData)
  }

  deleteProfilePhoto(id: string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`companies/${id}/delete-avatar`));
  }

  listAllForSelect(instructorID: string = null) {
    if(instructorID){
      return this.httpClient.get<ResultModel<CompanyModel[]>>(this.getApiUrl(`companies?pInstructorID=${instructorID}`));
    }
    else{
      return this.httpClient.get<ResultModel<CompanyModel[]>>(this.getApiUrl('companies'));
    }
  }

  listAll(formData:FormData) {
    return this.httpClient.post<ResultModel<CompanyModel[]>>(this.getApiUrl('companies/list'), formData);
  }

  create(company: CompanyModel, connection: ConnectionModel) {
    var queryParams = '';
    queryParams += this.getQueryString(connection);

    if (queryParams == '') {
      return this.httpClient.post<ResultModel>(this.getApiUrl("companies"), company);
    }
    else {
      return this.httpClient.post<ResultModel>(this.getApiUrl("companies?" + queryParams), company);
    }
  }

  update(company: CompanyModel) {
    return this.httpClient.put<ResultModel>(this.getApiUrl('companies'), company);
  }

  get(id:string) {
    return this.httpClient.get<{ Company: CompanyModel }>(this.getApiUrl('companies/' + id));
  }

  getAll(id:string) {
    return this.httpClient.get<{ Company: CompanyModel, Activity :ActivityModel[], Connection:ConnectionModel[],ConnectionFirst:ConnectionModel }>(this.getApiUrl('companies/all/' + id));
  }

  delete(id:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('companies/' + id));
  }

}
